import React from 'react';
type TikTokIconProps = {
  className?: string;
};
export function TikTokIcon({
  className
}: TikTokIconProps) {
  return <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true" focusable="false" data-id="element-315" data-mp="3hest0xip4yrp">
      <path d="M16.5 2h-3.02v13.62a2.6 2.6 0 1 1-2.6-2.6c.19 0 .38.02.56.06v-3.06a5.66 5.66 0 1 0 5.06 5.63V8.9a7.3 7.3 0 0 0 4.25 1.36V7.2a4.28 4.28 0 0 1-2.99-1.24A4.3 4.3 0 0 1 16.5 2Z" data-id="element-316" data-mp="3ckevopkh4hke" />
    </svg>;
}